"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
exports.Badge = ({ children, className, type = 'secondary', ...rest }) => {
    const badgeClassNames = classnames_1.default("badge", [`alert-${type}`], className);
    return react_1.default.createElement(styles_1.BadgeContainer, Object.assign({ className: badgeClassNames }, rest), children);
};
